import { Flex, Text } from "@chakra-ui/react";
import { faFile } from "@fortawesome/pro-light-svg-icons";
import { faArrowUpRightFromSquare } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ISubmissionFile } from "@publishing-engine/domain/models";
import FileViewerButtonText from "../Submission/FileViewerButtonText";

const FileComponent = ({ file }: {
  file: ISubmissionFile;

}) => {
  return (
    <Flex
      key={file.id || file.url}
      flexDirection="row"
      gap={2}
    >
      <Flex alignItems="center" gap={2} flexDirection="row">
        <FontAwesomeIcon icon={faFile} size='lg' />
        <Text textStyle="textBody">{file.name}</Text>
      </Flex>

      <Flex flexDirection={'row'} gap={8}>
        <FileViewerButtonText
          file={file}
          leftIcon={<FontAwesomeIcon icon={faArrowUpRightFromSquare} />}
        >
          View
        </FileViewerButtonText>
      </Flex>
    </Flex>
  )
}

export default FileComponent;